import React, { Component } from "react";
import debug from "debug";
import { ConsultantCardContentProps } from "./ConsultantCardContentBase";
import { ConsultantCardContent } from "./ConsultantCardContent";
import { ConsultantSearchCard_GetComponent } from "@graphql";

const log = debug("app:components:ConsultantCard");

type Props = Omit<ConsultantCardContentProps, "item"> & {
  consultantId: string;
  withEvents?: boolean;
};

class ConsultantCard extends Component<Props> {
  static defaultProps = {
    raised: true
  };

  render() {
    const { consultantId, withEvents, ...rest } = this.props;

    return (
      <ConsultantSearchCard_GetComponent
        variables={{ id: consultantId, withEvents: Boolean(withEvents) }}
      >
        {({ error, loading, data }) => {
          if (loading) {
            // this condition doesn't fulfill in cache-only mode
            log("loading");
            return null;
          }

          if (error) {
            console.error(error);
            return null;
          }

          if (!data.consultantById) {
            return <div>failed loading {consultantId}</div>;
          }

          return (
            <ConsultantCardContent
              details={[
                "availability",
                "email",
                "phone",
                "ssn",
                "lastContact",
                "employeeSalaryClaim",
                "subcontractorSalaryClaim"
              ]}
              item={data.consultantById}
              {...rest}
            />
          );
        }}
      </ConsultantSearchCard_GetComponent>
    );
  }
}

export default ConsultantCard;
